module.exports = __webpack_public_path__ + "img/rank-teacher-pic001.f01521f9.png";